import React from 'react';
import { motion } from 'framer-motion';

const Privacy = () => {
  const fadeInUp = {
    initial: { opacity: 0, y: 20 },
    whileInView: { opacity: 1, y: 0 },
    viewport: { once: true },
    transition: { duration: 0.5 }
  };

  return (
    <div>
      {/* Hero Section */}
      <section className="relative py-20 bg-gradient-to-br from-red-50/30 via-white to-gray-50/20">
        <div className="container mx-auto px-4 lg:px-8">
          <motion.div className="max-w-4xl mx-auto" {...fadeInUp}>
            <h1 className="text-4xl sm:text-5xl font-bold mb-6 text-[#ed3237]">Privacy Policy</h1>
            <p className="text-lg text-muted-foreground">Last updated: {new Date().toLocaleDateString()}</p>
          </motion.div>
        </div>
      </section>

      {/* Content */}
      <section className="py-16 lg:py-24">
        <div className="container mx-auto px-4 lg:px-8">
          <motion.div className="max-w-4xl mx-auto space-y-8 prose prose-lg" {...fadeInUp}>
            
            <div>
              <h2 className="text-2xl font-semibold text-[#ed3237] mb-4">1. Introduction</h2>
              <p className="text-muted-foreground">
                Big Bag Essentials ("we," "our," or "us") is committed to protecting your privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website bigbagessentials.in or use our services.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-semibold text-[#ed3237] mb-4">2. Information We Collect</h2>
              <h3 className="text-xl font-semibold mb-2">Personal Information</h3>
              <p className="text-muted-foreground mb-4">
                We may collect personal information that you voluntarily provide to us when you:
              </p>
              <ul className="list-disc pl-6 text-muted-foreground space-y-2">
                <li>Fill out contact forms or inquiry forms</li>
                <li>Request quotes for our products</li>
                <li>Subscribe to our newsletter</li>
                <li>Contact us via email or phone</li>
                <li>Interact with our website</li>
              </ul>
              <p className="text-muted-foreground mt-4">
                This information may include: name, company name, email address, phone number, business requirements, and any other information you choose to provide.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-semibold text-[#ed3237] mb-4">3. How We Use Your Information</h2>
              <p className="text-muted-foreground mb-4">
                We use the information we collect to:
              </p>
              <ul className="list-disc pl-6 text-muted-foreground space-y-2">
                <li>Respond to your inquiries and provide customer support</li>
                <li>Process your product quotes and orders</li>
                <li>Send you technical information about our products</li>
                <li>Improve our website and services</li>
                <li>Send marketing communications (with your consent)</li>
                <li>Comply with legal obligations</li>
                <li>Prevent fraudulent activities</li>
              </ul>
            </div>

            <div>
              <h2 className="text-2xl font-semibold text-[#ed3237] mb-4">4. Information Sharing and Disclosure</h2>
              <p className="text-muted-foreground mb-4">
                We do not sell, trade, or rent your personal information to third parties. We may share your information only in the following circumstances:
              </p>
              <ul className="list-disc pl-6 text-muted-foreground space-y-2">
                <li><strong>Service Providers:</strong> With trusted third-party service providers who assist in operating our website and conducting our business</li>
                <li><strong>Legal Requirements:</strong> When required by law or to protect our rights and safety</li>
                <li><strong>Business Transfers:</strong> In connection with any merger, sale of company assets, or acquisition</li>
              </ul>
            </div>

            <div>
              <h2 className="text-2xl font-semibold text-[#ed3237] mb-4">5. Data Security</h2>
              <p className="text-muted-foreground">
                We implement appropriate technical and organizational security measures to protect your personal information against unauthorized access, alteration, disclosure, or destruction. However, no method of transmission over the Internet or electronic storage is 100% secure.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-semibold text-[#ed3237] mb-4">6. Cookies and Tracking Technologies</h2>
              <p className="text-muted-foreground mb-4">
                Our website may use cookies and similar tracking technologies to enhance your browsing experience. You can control cookie settings through your browser preferences.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-semibold text-[#ed3237] mb-4">7. Your Rights</h2>
              <p className="text-muted-foreground mb-4">
                You have the right to:
              </p>
              <ul className="list-disc pl-6 text-muted-foreground space-y-2">
                <li>Access your personal information</li>
                <li>Correct inaccurate data</li>
                <li>Request deletion of your data</li>
                <li>Opt-out of marketing communications</li>
                <li>Object to processing of your data</li>
              </ul>
            </div>

            <div>
              <h2 className="text-2xl font-semibold text-[#ed3237] mb-4">8. Children's Privacy</h2>
              <p className="text-muted-foreground">
                Our services are not directed to individuals under the age of 18. We do not knowingly collect personal information from children.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-semibold text-[#ed3237] mb-4">9. Changes to This Privacy Policy</h2>
              <p className="text-muted-foreground">
                We may update this Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page and updating the "Last updated" date.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-semibold text-[#ed3237] mb-4">10. Contact Us</h2>
              <p className="text-muted-foreground mb-4">
                If you have any questions about this Privacy Policy, please contact us:
              </p>
              <div className="bg-muted/30 p-6 rounded-lg">
                <p className="font-semibold mb-2">Big Bag Essentials</p>
                <p className="text-muted-foreground mb-1">Email: anandsharma@bigbagessential.in</p>
                <p className="text-muted-foreground mb-1">Phone: +91 70733 39922, +91 94140 16053</p>
                <p className="text-muted-foreground">Address: No. 31, Panchwati Colony, Gayatri Nagar, Beawar, Rajasthan - 305901, India</p>
              </div>
            </div>

          </motion.div>
        </div>
      </section>
    </div>
  );
};

export default Privacy;
